module.exports = __webpack_public_path__ + "09_hair_black.6bf2f923.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/09_hair_black.png
// module id = ++uA
// module chunks = 0